<template>
  <v-form ref="form">
    <v-row class="mt-7 no-print">
      <v-col>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="isTableView ? 'secondary' : undefined"
              size="25"
              v-on="on"
              class="pr-3"
              @click="toggleBarsSelection"
            >
              fa fa-bars
            </v-icon>
          </template>
          <span>Tabela</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="isCardsView ? 'secondary' : undefined"
              size="25"
              v-on="on"
              class="pr-1"
              @click="toggleCardSelection"
            >
              fa fa-th
            </v-icon>
          </template>
          <span>Cards</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="isTableView == true">
      <v-row v-if="getQuotationProductivity.length > 0">
        <v-col cols="12" class="mt-6 mb-4">
          <h3 class="black--text mb-4">Seguro Agrícola Produtividade</h3>
          <v-data-table
            :headers="headerProductivity"
            :items="getQuotationProductivity"
            no-data-text="Nenhuma Cotação foi encontrada"
            loading-text="Carregando Cotações..."
            :options.sync="options"
            :server-items-length="getQuotationProductivity.length"
            class="quotation-table base__datatable reduced-visibility"
            @click:row="openPayment"
            item-key="item.index"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, 250, 500]
            }"
            :hide-default-footer="true"
          >
            <template v-slot:[`item.index`]="{ item }">
              {{ "1." + (getQuotationProductivity.indexOf(item) + 1) }}
            </template>
            <template v-slot:[`item.insuredArea`]="{ item }">
              {{ asNumberString(item.insuredArea) }}
            </template>
            <template v-slot:[`item.insuredValue`]="{ item }">
              {{ asNumberString(item.insuredValue) }}
            </template>
            <template v-slot:[`item.grantedProduction`]="{ item }">
              {{ asNumberString(item.grantedProduction) }}
            </template>
            <template v-slot:[`item.costPerSac`]="{ item }">
              {{ asNumberString(item.costPerSac) }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              {{ asNumberString(item.total) }}
            </template>
            <template v-slot:[`item.federalSubvention`]="{ item }">
              {{ asNumberString(item.federalSubvention) }}
            </template>
            <template v-slot:[`item.stateSubvention`]="{ item }">
              {{ asNumberString(item.stateSubvention) }}
            </template>
            <template v-slot:[`item.insuredPrice`]="{ item }">
              {{ asNumberString(item.insuredPrice) }}
            </template>
            <template v-slot:[`item.farmerPrice`]="{ item }">
              {{ asNumberString(item.farmerPrice) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-if="getQuotationCosting.length > 0">
        <v-col cols="12" class="mb-4 mt-4">
          <h3 class="black--text mb-4">Seguro Agrícola Custeio</h3>
          <v-data-table
            :headers="headerCosting"
            :items="getQuotationCosting"
            no-data-text="Nenhuma Cotação foi encontrada"
            loading-text="Carregando Cotações..."
            :options.sync="options"
            :server-items-length="getQuotationCosting.length"
            class="quotation-table base__datatable reduced-visibility"
            @click:row="openPayment"
            item-key="item.index"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, 250, 500]
            }"
            :hide-default-footer="true"
          >
            <template v-slot:[`item.index`]="{ item }">
              {{ "2." + (getQuotationCosting.indexOf(item) + 1) }}
            </template>
            <template v-slot:[`item.insuredArea`]="{ item }">
              {{ asNumberString(item.insuredArea) }}
            </template>
            <template v-slot:[`item.insuredValue`]="{ item }">
              {{ asNumberString(item.insuredValue) }}
            </template>
            <template v-slot:[`item.grantedProduction`]="{ item }">
              {{ asNumberString(item.grantedProduction) }}
            </template>
            <template v-slot:[`item.hectareCost`]="{ item }">
              {{ asNumberString(item.hectareCost) }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              {{ asNumberString(item.total) }}
            </template>
            <template v-slot:[`item.federalSubvention`]="{ item }">
              {{ asNumberString(item.federalSubvention) }}
            </template>
            <template v-slot:[`item.stateSubvention`]="{ item }">
              {{ asNumberString(item.stateSubvention) }}
            </template>
            <template v-slot:[`item.insuredPrice`]="{ item }">
              {{ asNumberString(item.insuredPrice) }}
            </template>
            <template v-slot:[`item.farmerPrice`]="{ item }">
              {{ asNumberString(item.farmerPrice) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-if="isCardsView == true">
      <template v-if="getQuotationProductivity.length > 0">
        <v-col
          v-for="(item, index) in getQuotationProductivity"
          :key="'productivity-' + index"
          cols="12"
          md="4"
          class="containerCard1"
        >
          <QuotationCostsCardAgricolaProdutividade
            ref="cardProdutividade"
            :item="item"
            :index="index"
            @open-payment="openPayment"
            class="cards"
          />
        </v-col>
      </template>
      <template v-if="getQuotationCosting.length > 0">
        <v-col
          v-for="(item, index) in getQuotationCosting"
          :key="'costing-' + index"
          cols="12"
          md="4"
          class="containerCard2"
        >
          <QuotationCostsCardAgricolaCusteio
            ref="cardCusteio"
            :item="item"
            :index="index"
            @open-payment="openPayment"
            class="cards"
          />
        </v-col>
      </template>
    </v-row>
    <v-row v-if="currentQuotation.cancelada_em == null">
      <v-col
        cols="12"
        class="deadline-emission-type__disclaimer pa-4 mt-3 mb-3 no-print"
      >
        <img src="@/assets/ic_warning.svg" class="px-1" />
        <label class="primary--text caption mb-0">
          As cotações dispostas nesta página são uma prévia.
          <a @click="imprimir()" style="text-decoration: underline black"
            >Faça o download</a
          >
          para acessar a proposta completa e suas condições.
        </label>
      </v-col>
    </v-row>
    <v-dialog
      v-if="currentQuotation.cancelada_em == null && showPayment"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showPayment"
      width="700px"
    >
      <v-row class="white px-6 py-8">
        <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
          <BaseMoney
            id-element="total"
            placeholder=""
            v-model="form.selectedCost.insuredPrice"
            label-text="Valor do prêmio"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pr-0 pr-md-5">
          <BaseFormSelect
            id-element="paymentForm"
            placeholder=""
            :items="paymentForm"
            v-model="form.avista_parcelado"
            label-text="Forma Pagamento"
            item-text="name"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :readonly="paymentFormAvista"
            @change="onChangeFormaPagamento"
          />
        </v-col>
        <v-col cols="12" sm="6" md="5" class="pr-0">
          <BaseFormSelect
            id-element="payments"
            placeholder=""
            v-model="form.forma_pagamento"
            label-text="Número de Parcelas"
            :items="getPayments"
            item-text="name"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :readonly="paymentFormAvista"
          />
        </v-col>
      </v-row>
      <v-row cols="12" class="white d-flex justify-end">
        <v-col cols="2" class="mb-6">
          <BaseButton
            v-html="'Próximo'"
            class="white--text secondary"
            @click="openModal()"
          />
        </v-col>
      </v-row>
    </v-dialog>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showModal"
      v-if="showModal"
    >
      <QuotationAgroModal
        :selectedItem="form.selectedCost"
        :formInsured="formInsured"
        :formCost="formCost"
        :formProduct="formProduct"
        :formRisk="formRisk"
        :paymentForm="form.forma_pagamento"
        @accept="redirectToHiring"
        @cancel="closeModal"
      />
    </v-dialog>
    <v-row
      class="d-flex justify-end"
      v-if="currentQuotation.cancelada_em == null"
    >
      <v-col cols="3" class="mt-2 mb-8">
        <BaseButton
          v-html="'Imprimir'"
          class="white--text secondary"
          width="100%"
          @click="imprimir()"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeadersProductivity = [
  { text: "Id", value: "index", sortable: false, width: "10px" },
  { text: "Seguradora", value: "insuranceCompany.nome", sortable: false, width: "90px" },
  { text: "Área (ha)", value: "insuredArea", sortable: false },
  { text: "Regulação Sinistro", value: "claimType.nome", sortable: false },
  { text: "Coberturas", value: "coverage.nome", sortable: false },
  { text: "Importância Segurada (R$)", value: "insuredValue", sortable: false },
  {
    text: "Produtividade Garantida",
    value: "grantedProduction",
    sortable: false,
    width: "80px"
  },
  { text: "Preço da Saca (R$)", value: "costPerSac", sortable: false },
  { text: "Preço Total (R$)", value: "total", sortable: false },
  {
    text: "Subvenção Federal (R$)",
    value: "federalSubvention",
    sortable: false
  },
  {
    text: "Subvenção Estadual (R$)",
    value: "stateSubvention",
    sortable: false
  },
  { text: "Preço do Segurado (R$)", value: "insuredPrice", sortable: false },
  { text: "Preço do produtor (R$/ha)", value: "farmerPrice", sortable: false },
  { text: "Forma de Pagamento", value: "paymentForm.nome", sortable: false }
];
const tableHeadersCosting = [
  { text: "Id", value: "index", sortable: false, width: "10px" },
  { text: "Seguradora", value: "insuranceCompany.nome", sortable: false, width: "90px" },
  { text: "Área (ha)", value: "insuredArea", sortable: false },
  { text: "Regulação Sinistro", value: "claimType.nome", sortable: false },
  { text: "Coberturas", value: "coverage.nome", sortable: false },
  { text: "Importância Segurada (R$)", value: "insuredValue", sortable: false },
  {
    text: "Produtividade Garantida",
    value: "grantedProduction",
    sortable: false,
    width: "80px"
  },
  { text: "Valor por Hectare (R$)", value: "hectareCost", sortable: false },
  { text: "Preço Total (R$)", value: "total", sortable: false },
  {
    text: "Subvenção Federal (R$)",
    value: "federalSubvention",
    sortable: false
  },
  {
    text: "Subvenção Estadual (R$)",
    value: "stateSubvention",
    sortable: false
  },
  { text: "Preço do Segurado (R$)", value: "insuredPrice", sortable: false },
  { text: "Preço do produtor (R$/ha)", value: "farmerPrice", sortable: false },
  { text: "Forma de Pagamento", value: "paymentForm.nome", sortable: false }
];
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "apolice_emitida" },
  { color: "light-blue", status: "aguardando_emissao_minuta" },
  { color: "light-blue", status: "aguardando_analise_minuta" },
  { color: "yellow", status: "em_andamento" }
];
const DEFAULT_STATUS = { color: "yellow" };

const defaultPaymentForm = [
  {
    id: "avista",
    name: "À vista"
  },
  {
    id: "parcelado",
    name: "Parcelado"
  }
];

import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import QuotationAgroModal from "../views/QuotationAgroModal.vue";
import QuotationCostsCardAgricolaProdutividade from "./QuotationCostsCardAgricolaProdutividade.vue";
import QuotationCostsCardAgricolaCusteio from "./QuotationCostsCardAgricolaCusteio.vue";
export default {
  components: {
    QuotationAgroModal,
    QuotationCostsCardAgricolaProdutividade,
    QuotationCostsCardAgricolaCusteio
  },
  data() {
    return {
      headerProductivity: tableHeadersProductivity,
      headerCosting: tableHeadersCosting,
      listColorByStatus: colorByStatus,
      formatExpirationDate,
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput,
      asNumberString,
      showModal: false,
      showPayment: false,
      paymentForm: defaultPaymentForm,
      payments: [],
      isTableView: true,
      isCardsView: false
    };
  },
  props: {
    form: {
      modalOpen: false,
      selectedItem: {}
    },
    formInsured: {
      type: Object
    },
    formCost: {
      type: Object
    },
    formProduct: {
      type: Object
    },
    formRisk: {
      type: Object
    }
  },
  mixins: [LoadingRequest, CommonPayload, QuotationMixin],
  created() {
    this.loadPayments();
    this.setPaymentForm();
  },
  computed: {
    ...mapState("quotation", [
      "statusCurrentQuotation",
      "infoCostQuotation",
      "currentQuotationAgro",
      "listQuotationCostsAgro",
      "currentQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    getQuotationProductivity() {
      return this.filterCostsProdutividade();
    },
    getQuotationCosting() {
      return this.filterCostsCusteio();
    },
    getPayments() {
      let list = this.payments;
      if (this.form.avista_parcelado?.id === "avista") {
        list = this.payments.filter(x => x.id == "1");
      } else if (this.form.avista_parcelado?.id === "parcelado") {
        list = this.payments.filter(x => x.id != "1");
      }
      return list;
    },
    paymentFormAvista() {
      return this.form.selectedCost.paymentForm.id == "1" ? true : false;
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestStatusCurrentQuotation",
      "requestListQuotationCostsAgro",
      "requestCurrentQuotation"
    ]),
    filterCostsCusteio() {
      if (this.formCost.quotationCosts.length > 0)
        return this.formCost.quotationCosts.filter(
          a => a.insuranceType?.id == "custeio"
        );
      return [];
    },
    filterCostsProdutividade() {
      if (this.formCost.quotationCosts.length > 0)
        return this.formCost.quotationCosts.filter(
          a => a.insuranceType?.id == "produtividade"
        );
      return [];
    },
    loadPayments() {
      if (this.form.selectedCost == null) return;

      this.payments = [];

      for (let i = 1; i <= Number(this.form.selectedCost.paymentForm.id); i++) {
        this.payments.push({
          id: i,
          name:
            i +
            "x R$ " +
            asNumberString(this.form.selectedCost.insuredPrice / i)
        });
      }
    },
    onChangeFormaPagamento() {
      this.form.forma_pagamento = this.getPayments[this.getPayments.length - 1];
    },
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `quotation-table__border-${status.color}`;
    },
    setPaymentForm() {
      this.form.avista_parcelado = this.paymentForm.find(x => x.id == "avista");
      if (Number(this.form.selectedCost?.paymentForm.id) > 1) {
        this.form.avista_parcelado = this.paymentForm.find(
          x => x.id == "parcelado"
        );
      }
    },
    openModal() {
      if (!this.$refs.form.validate()) return;
      this.showPayment = false;
      this.showModal = true;
    },
    openPayment(item) {
      this.form.selectedCost = item;
      
      this.loadPayments();
      this.setPaymentForm();
      this.onChangeFormaPagamento();
      this.showModal = false;
      this.showPayment = true;
    },
    closeModal() {
      this.showModal = false;
    },
    redirectToHiring() {
      this.$emit("submit", this.form);
    },
    async fetchStatusQuotation() {
      await this.requestStatusCurrentQuotation(this.$route.params.id);
    },
    imprimir() {
      const item = this.formCost.numero_cotacao;
      this.$router.push({
        name: "quotation agro",
        params: {
          id: item,
          isTableView: this.isTableView
        }
      });
    },
    toggleBarsSelection() {
      this.isTableView = !this.isTableView;
      // Desmarcar o outro ícone quando este for selecionado
      if (this.isTableView) {
        this.isCardsView = false;
      }
    },
    toggleCardSelection() {
      this.isCardsView = !this.isCardsView;
      // Desmarcar o outro ícone quando este for selecionado
      if (this.isCardsView) {
        this.isTableView = false;
      }
    }
  }
};
</script>
<style lang="sass">
.deadline-emission-type__
  &disclaimer
    border-radius: 4px
    background-color: #FFC55F
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
.reduced-visibility
  table
    table-layout: fixed
    width: 100% !important
    padding-right: 20px !important
    background-color: #FFFFFF !important
  thead tr th:last-child
    padding-left: 10px !important
    width: 80px !important
  tbody tr:hover
    opacity: 0.8
  tbody tr td
    cursor: pointer !important
    font-size: 11px !important
    padding-left: 20px !important
.containerCard1
  display: flex
  flex-wrap: wrap
  padding-right: 20px
  margin-top: 30px
.containerCard2
  display: flex
  flex-wrap: wrap
  padding-right: 20px
  margin-top: 30px
@media print
  .no-print
    display: none
  .cards
    padding-top: 80px
    margin-bottom: 200px
    width: 310px
    height: 450px
</style>
